import { Navigate, RouteObject } from 'react-router-dom';
import { EvalLayout } from './components/layout/EvalLayout';
import { DatasetCreatePage } from './pages/datasets/DatasetCreatePage';
import { DatasetDetailPage } from './pages/datasets/DatasetDetailPage';
import { DatasetListPage } from './pages/datasets/DatasetListPage';
import { InferencePickerPage } from './pages/gt-inferences/InferencePickerPage';
import { GtSamplePage } from './pages/gt-samples/GtSamplePage';
import { GtSamplesListPage } from './pages/gt-samples/GtSamplesListPage';
import { MetricsPage } from './pages/metrics/MetricsPage';
import { ModelDetailPage } from './pages/models/ModelDetailPage';
import { ModelListPage } from './pages/models/ModelListPage';
import { CompareRunsPage } from './pages/runs/CompareRunsPage';
import { RunDetailPage } from './pages/runs/RunDetailPage';
import { RunInferenceSamplePage } from './pages/runs/RunInferenceSamplePage';
import { RunListPage } from './pages/runs/RunListPage';
import { RunSchedulerPage } from './pages/runs/RunSchedulerPage';

export const evalRoutes: RouteObject = {
  path: '/eval',
  element: <EvalLayout />,
  children: [
    { index: true, element: <Navigate to="runs" replace /> },
    { path: 'runs', element: <RunListPage /> },
    { path: 'runs/new', element: <RunSchedulerPage /> },
    { path: 'runs/compare', element: <CompareRunsPage /> },
    { path: 'runs/:runId', element: <RunDetailPage /> },
    { path: 'runs/:runId/inferences/:runInferenceId', element: <RunInferenceSamplePage /> },
    { path: 'datasets', element: <DatasetListPage /> },
    { path: 'datasets/new', element: <DatasetCreatePage /> },
    { path: 'datasets/:datasetId', element: <DatasetDetailPage /> },
    { path: 'gt-samples', element: <GtSamplesListPage /> },
    { path: 'gt-samples/:gtSampleId', element: <GtSamplePage /> },
    { path: 'pr-inferences', element: <InferencePickerPage /> },
    { path: 'models', element: <ModelListPage /> },
    { path: 'models/:modelId', element: <ModelDetailPage /> },
    { path: 'metrics', element: <MetricsPage /> },
  ],
};
